export const DECELERATION_RATE = 0.96;
export const VELOCITY_THRESHOLD = 0.4;
export const INITIAL_SPEEDUP = 10;
export const MAX_VELOCITY = 60;
export const CLICK_PIXEL_THRESHOLD = 5;
export const CLICK_MILLISECONDS_THRESHOLD = 200;
